import { useMutation } from '@apollo/client/react'
import * as Sentry from '@sentry/react'
import { toast } from 'sonner'
import {
  PortalMyOrganizationDocument,
  PortalUpdateOrganizationDocument,
  type PortalUpdateOrganizationMutation,
  type PortalUpdateOrganizationMutationVariables,
} from '@/graphql/generated/graphql'

interface UseUpdateOrganizationOptions {
  onSuccess?: () => void
}

export function useUpdateOrganization({ onSuccess }: UseUpdateOrganizationOptions = {}) {
  const [mutate, { loading, error }] = useMutation<
    PortalUpdateOrganizationMutation,
    PortalUpdateOrganizationMutationVariables
  >(PortalUpdateOrganizationDocument, {
    refetchQueries: [{ query: PortalMyOrganizationDocument }],
    awaitRefetchQueries: true,
    onError: (err) => {
      Sentry.captureException(err, {
        tags: { operation: 'PortalUpdateOrganization' },
      })
      toast.error('No se pudo guardar la organización', {
        description: err.message,
      })
    },
  })

  const updateOrganization = async (
    input: PortalUpdateOrganizationMutationVariables['input'],
  ) => {
    const result = await mutate({ variables: { input } })
    if (result.data?.portalUpdateOrganization && onSuccess) onSuccess()
    return result.data?.portalUpdateOrganization ?? false
  }

  return { updateOrganization, loading, error }
}
